(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-slider')) {
    customElements.define('countdown-slider', class CountdownSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-countdown-slide]'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('[data-countdown-dot]'));
        this.prevBtn = this.querySelector('[data-countdown-prev]');
        this.nextBtn = this.querySelector('[data-countdown-next]');
        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.timer = null;
        this.touchStartX = 0;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.goTo = this.goTo.bind(this);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.startAutoplay = this.startAutoplay.bind(this);
        this.stopAutoplay = this.stopAutoplay.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', this.prev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this.next);
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });

        this.addEventListener('mouseenter', this.stopAutoplay);
        this.addEventListener('mouseleave', this.startAutoplay);
        this.addEventListener('focusin', this.stopAutoplay);
        this.addEventListener('focusout', this.startAutoplay);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        if (this.autoplay && !this.reducedMotion) this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      goTo(index) {
        if (!this.slides.length) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === nextIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, i) => {
          const active = i === nextIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        this.index = nextIndex;
      }

      next() {
        this.goTo(this.index + 1);
      }

      prev() {
        this.goTo(this.index - 1);
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplay || this.reducedMotion || this.slides.length < 2) return;
        this.timer = setInterval(this.next, this.speed);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      onBlockSelect(event) {
        const slide = this.slides.find((el) => el.dataset.slideId === event.detail.blockId);
        if (!slide) return;
        this.stopAutoplay();
        this.goTo(this.slides.indexOf(slide));
      }

      onBlockDeselect(event) {
        const slide = this.slides.find((el) => el.dataset.slideId === event.detail.blockId);
        if (!slide) return;
        this.startAutoplay();
      }

      onTouchStart(event) {
        this.touchStartX = event.changedTouches[0].screenX;
      }

      onTouchEnd(event) {
        const diff = event.changedTouches[0].screenX - this.touchStartX;
        if (Math.abs(diff) < 40) return;
        if (diff < 0) this.next();
        else this.prev();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
